export const listDisponibilidades = [
  {
    label: "Ex.: Publicadas...",
    value: null,
    disabled: true,
  },
  { label: "Aceitando submissões", value: "aceitando-submissoes" },
  { label: "Encerradas", value: "encerradas" },
  { label: "Publicadas", value: "publicadas" },
  { label: "Todas", value: "todas" },
];
